import { request } from './client';
import type {
  CounterpartyFinance, ExpenseItem, FinanceAccount, FinanceAccountInput, FinanceAccountTransferCreate, FinanceAdvanceApply, FinanceExpenseCreate,
  FinancePaymentCreate, FinancePaymentResult, FinanceSimpleResult,
} from '@kassa/shared';

// Maliyyə → «Yeni ödəniş» və «Hesablar» (KT-102)
export const financeApi = {
  financeAccounts: () => request<FinanceAccount[]>('GET', '/api/finance/accounts'),
  financeAccountCreate: (body: FinanceAccountInput) => request<{ id: string }>('POST', '/api/finance/accounts', body),
  financeCounterparty: (id: string) => request<CounterpartyFinance>('GET', `/api/finance/counterparties/${encodeURIComponent(id)}`),
  financePay: (body: FinancePaymentCreate) => request<FinancePaymentResult>('POST', '/api/finance/payments', body),
  financeReverse: (paymentId: string, id: string) => request<FinanceSimpleResult>('POST', `/api/finance/payments/${encodeURIComponent(paymentId)}/reverse`, { id }),
  financeAdvance: (body: FinanceAdvanceApply) => request<FinancePaymentResult>('POST', '/api/finance/advance', body),
  expenseItems: () => request<ExpenseItem[]>('GET', '/api/finance/expense-items'),
  expenseItemCreate: (name: string) => request<{ id: string }>('POST', '/api/finance/expense-items', { name }),
  financeExpense: (body: FinanceExpenseCreate) => request<FinanceSimpleResult>('POST', '/api/finance/expenses', body),
  financeAccountTransfer: (body: FinanceAccountTransferCreate) => request<FinanceSimpleResult>('POST', '/api/finance/account-transfers', body),
};
